import React from 'react';
import ModuleOperationsPage from './ModuleOperationsPage';

const SwapOperationsPage: React.FC = () => (
  <ModuleOperationsPage
    category="swap"
    moduleKey="swap"
    title="Swap Operations"
    description="Swap money movements with the platform's collected fees and balance."
  />
);

export default SwapOperationsPage;
